import { ComponentType } from 'react'

export const getDisplayName = <T>(WrappedComponent: ComponentType<T>): string =>
  WrappedComponent.displayName || WrappedComponent.name || 'Component'
